/**
 * Розумно форматує ціну залежно від її величини.
 * @param {number | string} price - Ціна для форматування.
 * @returns {string} - Відформатований рядок ціни.
 */
export const formatPrice = (price) => {
  const priceNumber = parseFloat(price);

  if (isNaN(priceNumber)) {
    return '0.00'; // Повертаємо значення за замовчуванням, якщо вхідні дані некоректні
  }

  // Визначаємо кількість знаків після коми
  let decimalPlaces;

  if (priceNumber >= 1000) {
    // Для великих чисел, як BTC
    decimalPlaces = 2;
  } else if (priceNumber >= 10) {
    // Для середніх чисел
    decimalPlaces = 3;
  } else if (priceNumber >= 0.1) {
    // Для чисел менше 10
    decimalPlaces = 4;
  } else {
    // Для дуже маленьких чисел, як PEPE або SHIB
    // Рахуємо кількість нулів після коми до першої значущої цифри
    const match = price.toString().match(/(\.0*)/);
    if (match && match[1]) {
      // Додаємо 3 значущі цифри після нулів
      decimalPlaces = match[1].length - 1 + 3;
    } else {
      // Якщо щось пішло не так, або число типу 0.0... без нулів
      decimalPlaces = 6;
    }
    // Обмежуємо максимальну кількість знаків, щоб уникнути занадто довгих рядків
    if (decimalPlaces > 8) {
      decimalPlaces = 8;
    }
  }

  return priceNumber.toFixed(decimalPlaces);
};